module.exports = __webpack_public_path__ + "static/media/square-rss-solid-full.1ef4706a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square-rss-solid-full.svg
// module id = 382
// module chunks = 0